/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pt-option.vue?vue&type=template&id=b82d52da&"
import script from "./pt-option.vue?vue&type=script&lang=js&"
export * from "./pt-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports